import type { Dayjs } from 'dayjs'
import type { DailyCloseSearch } from '@/services/inventory/dailyClose/types'
import { DATE_PARAM_FORMAT, MAX_SEARCH_DAYS, MESSAGES } from './constants'

export interface DailyCloseFormValues {
  shipperCode?: string
  closeDateRange?: readonly [Dayjs | null, Dayjs | null] | null
  warehouseName?: string
  logisticsServiceType?: string
}

/** URL 복원 자동 조회와 폼 제출에 동일한 교차 필드 검증 결과를 사용한다. */
export const validateDailyCloseForm = (values: DailyCloseFormValues): string | null => {
  const [from, to] = values.closeDateRange ?? []
  if (!from || !to) return MESSAGES.closeDateRequired
  if (from.isAfter(to, 'day')) return MESSAGES.closeDateInvalidRange
  if (to.diff(from, 'day') + 1 > MAX_SEARCH_DAYS) return MESSAGES.closeDatePeriodExceeded
  if (!values.shipperCode?.trim() && !values.logisticsServiceType?.trim()) return MESSAGES.shipperOrServiceTypeRequired
  return null
}

const trimmed = (value?: string): string | undefined => value?.trim() || undefined

export const toDailyCloseSearch = (values: DailyCloseFormValues): DailyCloseSearch => {
  const [from, to] = values.closeDateRange as readonly [Dayjs, Dayjs]
  const shipperCode = trimmed(values.shipperCode)
  const warehouseName = trimmed(values.warehouseName)
  const logisticsServiceType = trimmed(values.logisticsServiceType)

  return {
    ...(shipperCode ? { shipperCode } : {}),
    closeDateFrom: from.format(DATE_PARAM_FORMAT),
    closeDateTo: to.format(DATE_PARAM_FORMAT),
    ...(warehouseName ? { warehouseName } : {}),
    ...(logisticsServiceType ? { logisticsServiceType } : {}),
  }
}
